import axios, { parseAxiosError } from '@/react/portainer/services/axios/axios';
import { TeamMembership } from '@/react/portainer/users/teams/types';

import { UserId } from './types';
import { buildUrl } from './buildUrl';

export async function getUserMemberships(
  id: UserId,
  options: { signal?: AbortSignal } = {}
) {
  try {
    const { data } = await axios.get<TeamMembership[]>(
      buildUrl(id, 'memberships'),
      { signal: options.signal }
    );
    return data;
  } catch (err) {
    throw parseAxiosError(err as Error, 'Unable to retrieve user memberships');
  }
}
